/**
 * Play a short, tasteful "win" chime using Web Audio API.
 * No audio assets needed. Cheerful major-triad arpeggio (C5 -> E5 -> G5).
 * Silently no-ops if AudioContext is unavailable.
 */
export const playWinChime = () => {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();

    const notes = [
      { freq: 523.25, at: 0.00, dur: 0.18 }, // C5
      { freq: 659.25, at: 0.12, dur: 0.20 }, // E5
      { freq: 783.99, at: 0.24, dur: 0.32 }, // G5
    ];

    const master = ctx.createGain();
    master.gain.value = 0.18; // subtle, not startling
    master.connect(ctx.destination);

    const now = ctx.currentTime;
    notes.forEach(({ freq, at, dur }) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      // quick attack, gentle release
      g.gain.setValueAtTime(0, now + at);
      g.gain.linearRampToValueAtTime(1, now + at + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + at + dur);
      osc.connect(g).connect(master);
      osc.start(now + at);
      osc.stop(now + at + dur + 0.02);
    });

    // Close the context after playback so we don't leak audio resources
    setTimeout(() => {
      try { ctx.close(); } catch { /* ignore */ }
    }, 800);
  } catch {
    // AudioContext blocked (autoplay policy) — silently ignore
  }
};

export default playWinChime;
